// Featured story module data. See: SITE-584

export const FEATURED_STORY_MODULE_DATA = {
  display_order: 4,
  id: 1000000,
  is_active: true,
  page_id: 36,
  page_url: 'https://www.refinery29.com/en-us',
  shouldDisplayModuleTitle: true,
  rows: [
    {
      display_order: 1,
      indexWithinModule: 1,
      entities: [
        {
          object: {
            id: 10222528,
            type: 'SCROLLABLE',
            url: '/en-us/most-wanted',
            url_full: 'https://www.refinery29.com/en-us/most-wanted',
            excerpt_truncated_155: 'Update: As of 2:00 p.m., the code TAKE150 is now invalid. Intermix has kindly informed us the code was originally intended for a select set of customers ex',
            label: 'MOST WANTED',
            truncated_title_62: 'A Portrait Of 2020, As Told By The 12 Products YOU Bought Most',
            truncated_title_80: 'A Portrait Of 2020, As Told By The 12 Products YOU Bought Most',
            published: 1609264606,
            original_published: 1609264606,
            hero_shorter_title: 'Cart The Best Trends, Deals & Editors\' Favorites',
            truncated_short_title_80: 'A Portrait Of 2020, As Told By The 12 Products YOU Bought Most',
            excerpt_truncated_325: 'In a few days, 2020 will be a closed chapter in the book titled Well, That Was A Weird Year. Although most of us are ready to shove that tome to the back of life&#8217;s proverbial bookshelf, there are still feel-good memories tucked within its pages that are worth revisiting — times when we lifted...',
            asset_main: {
              id: 10252860,
              width: 2000,
              height: 2400,
              output_quality: 80,
              code: 'entry',
              format: 'jpeg',
              title: null,
              alt_title: null,
              type: 'IMAGE',
              description: null,
              credit: null,
              clicktracker: null,
              impressiontracker: null,
              no_pin_it: 0,
              no_facebook: 0,
              crop_w: null,
              crop_h: null,
              crop_x: null,
              crop_y: null,
              src_full: 'https://www.refinery29.com/images/10252860.jpg'
            },
            campaign_branding_image_mobile_url: null,
            opener_images: [
              {
                'type': '3x4',
                'label': '3:4',
                'alt_title': '',
                'asset': {
                  'credit': '',
                  'src': {
                    'full': 'https://www.refinery29.com/images/10252860.jpg?crop=3%3A4'
                  }
                }
              },
              {
                'type': '4x3',
                'label': '4:3',
                'alt_title': '',
                'asset': {
                  'credit': '',
                  'src': {
                    'full': 'https://www.refinery29.com/images/10252860.jpg?crop=4%3A3'
                  }
                }
              },
              {
                'type': '5x6',
                'label': '5:6',
                'alt_title': '',
                'asset': {
                  'credit': '',
                  'src': {
                    'full': 'https://www.refinery29.com/images/10252860.jpg?crop=5%3A6'
                  }
                }
              },
              {
                'type': '8x3',
                'label': '8:3',
                'alt_title': '',
                'asset': {
                  'credit': '',
                  'src': {
                    'full': 'https://www.refinery29.com/images/10252860.jpg?crop=8%3A3'
                  }
                }
              },
              {
                'type': '9x16',
                'label': '9:16',
                'alt_title': '',
                'asset': {
                  'credit': '',
                  'src': {
                    'full': 'https://www.refinery29.com/images/10252860.jpg?crop=9%3A16'
                  }
                }
              },
              {
                'type': '16x9',
                'label': '16:9',
                'alt_title': '',
                'asset': {
                  'credit': '',
                  'src': {
                    'full': 'https://www.refinery29.com/images/10252860.jpg?crop=16%3A9'
                  }
                }
              }
            ],
            contributors: [
              {
                display_name: 'Refinery29'
              }
            ],
            meta: {
              sold_content_type: ''
            },
            simplereach: {
              authors: [
                'Refinery29'
              ],
              tags: [
                'SCROLLABLE'
              ],
              channels: [
                'shopping'
              ]
            },
            is_video_card: false,
            blog_series: { }
          },
          type: 'blog_entry'
        }
      ],
      id: 10000000,
      type: '1-featured-story'
    }
  ],
  site_id: 'us',
  tag_id: 0,
  title: 'Editor\'s Pick',
  type: 'hp_refresh_featured_story'
};
